import { Toaster } from '@crestrewards/ui';

import { AuthProvider } from './shared/hooks/useAuth';
import AppRoutes from './shared/routes/AppRoutes';

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
      <Toaster />
    </AuthProvider>
  );
}
